import $ from 'jquery';

const selectors = {
	competition: '.js-competition-search',
	pouleSelection: '.js-poule-select',
	linkButton: '.js-link-button',
	standings: '.js-standings-result',
};

const sessionName = 'cs'; // competition search

export default class Competition {
	constructor(element) {
		this.element = element;
		this.baseUrl = $(selectors.competition).data('searchapi-url');
		this.standingsUrl = $(selectors.competition).data('standingsapi-url');

		this.league = $(this.element).find('#radio-league').val();
		this.club = $(this.element).find('#radio-club').val();

		this.currentSelectedId = $(this.element)
			.find('input[name="search-criteria"]:checked')
			.attr('id');

		this.parseData = this.parseData.bind(this);

		this.dropdownChanged = this.dropdownChanged.bind(this);
		$(this.element).find('select').change(this.dropdownChanged);

		this.radioChanged = this.radioChanged.bind(this);
		$(this.element).find('input[type="radio"]').change(this.radioChanged);

		this.requestSearchResult();

		this.requestStandings();
	}

	requestSearchResult(getData) {
		const url =
			getData !== null && typeof getData !== 'undefined'
				? `${this.baseUrl}?${getData}`
				: `${this.baseUrl}?${this.getHistory()}`;

		$.ajax({
			url,
			type: 'GET',
			context: this,
		})
			.done((result) => {
				if (
					(getData === null || typeof getData === 'undefined') &&
					this.getHistory() !== ''
				) {
					// Restore data by using the parameters from the query string
					this.parseData(result, true);
					this.restoreLastSearch();

					if (
						this.getHistory('sc') === this.league ||
						this.getHistory('sc').toLowerCase() === 'competitie'
					) {
						this.requestStandings(
							$(this.element).find('select[data-key="Groups"]').val()
						);
					} else if (
						this.getHistory('sc') === this.club ||
						this.getHistory('sc').toLowerCase() === 'club'
					) {
						this.requestStandings(
							$(this.element).find('select[data-key="Teams"]').val()
						);
					}
				} else {
					// Set data when the page is loaded without a query string
					this.parseData(result, false);
				}
			})
			.fail((error) => {
				console.error('Error while requesting search results.', error);
			});
	}

	restoreLastSearch() {
		$(this.element).find('select[data-key="Seasons"]').val(this.getHistory('s'));
		$(this.element).find('select[data-key="Leagues"]').val(this.getHistory('l'));
		$(this.element)
			.find('select[data-key="CompetitionClasses"]')
			.val(this.getHistory('c'));
		$(this.element).find('select[data-key="Groups"]').val(this.getHistory('g'));
		$(this.element).find('select[data-key="Clubs"]').val(this.getHistory('cl'));
		$(this.element).find('select[data-key="Teams"]').val(this.getHistory('t'));
	}

	requestStandings(groupID) {
		if (groupID == null || typeof groupID === 'undefined') {
			return;
		}

		$.ajax({
			url: `${this.standingsUrl}?groupId=${groupID}`,
			type: 'GET',
			context: this,
		})
			.done((result) => {
				this.updateStandings(result);
			})
			.fail((error) => {
				console.error('Error while requesting standings.', error);
			});
	}

	parseData(data, skipStandingsUpdate) {
		const selectedPouleBefore = $(this.element)
			.find('select[data-key="Groups"]')
			.val();
		const selectedTeamBefore = $(this.element)
			.find('select[data-key="Teams"]')
			.val();

		for (var key in data) {
			if (data[key] !== null) {
				const dropdown = $(this.element).find(`[data-key='${key}']`);
				this.updateDropdown(dropdown, data[key]);
			}
		}

		const selectedPouleAfter = $(this.element)
			.find('select[data-key="Groups"]')
			.val();
		const selectedTeamAfter = $(this.element)
			.find('select[data-key="Teams"]')
			.val();

		if (!skipStandingsUpdate) {
			if (
				$(this.element).find('input[name="search-criteria"]:checked').val() ===
					this.club &&
				selectedTeamBefore !== selectedTeamAfter
			) {
				this.requestStandings(selectedTeamAfter);
			} else if (selectedPouleBefore !== selectedPouleAfter) {
				this.requestStandings(selectedPouleAfter);
			}
		}
	}

	updateDropdown($dropdown, data) {
		if ($dropdown !== null && typeof $dropdown !== 'undefined' && data !== null) {
			$dropdown.empty();
			$.each(data, (i) => {
				const item = data[i];
				const id = $dropdown[0].id === 'team' ? item.PouleId : item.Id;
				const url = item.Url ? `data-url="${item.Url}"` : '';
				$dropdown.append(
					`<option value="${id}" ${url}>${item.Description}</option>`
				);
			});
		}
	}

	dropdownChanged(event) {
		const endpoint = event.target.getAttribute('data-endpoint');
		const selectedValue = event.target.value;

		let query = `${endpoint}=${selectedValue}`;

		if (event.target.id === 'league' || event.target.id === 'club') {
			query += `&seasonid=${$('#season').val()}`;
		}

		if (event.target.id === 'poule' || event.target.id === 'team') {
			this.requestStandings(event.target.value);
			return;
		}

		this.requestSearchResult(query);

		if (event.target.id === 'club') {
			this.changeLink(event);
		}
	}

	radioChanged(event) {
		const id = event.target.id;
		if (id !== this.currentSelectedId) {
			this.currentSelectedId = id;
			$(this.element).find(selectors.pouleSelection).toggleClass('hide');

			$(this.element)
				.find(`${selectors.pouleSelection}:visible`)
				.find('select:last')
				.change();
		}
	}

	changeLink(event) {
		const url = event.target.selectedOptions[0].getAttribute('data-url');
		if (url === null || typeof url === 'undefined') {
			$(this.element).find(selectors.linkButton).hide();
		} else {
			const text =
				$(this.element).find(selectors.linkButton).data('value') +
				event.target.selectedOptions[0].text;
			$(this.element).find(selectors.linkButton).attr('href', url).text(text);
			$(this.element).find(selectors.linkButton).show();
		}
	}

	updateStandings(data) {
		this.setHistory(
			`s=${$(this.element).find('select[data-key="Seasons"]').val()}&l=${$(
				this.element
			)
				.find('select[data-key="Leagues"]')
				.val()}&c=${$(this.element)
				.find('select[data-key="CompetitionClasses"]')
				.val()}&g=${$(this.element).find('select[data-key="Groups"]').val()}&cl=${$(
				this.element
			)
				.find('select[data-key="Clubs"]')
				.val()}&t=${$(this.element).find('select[data-key="Teams"]').val()}&sc=${$(
				this.element
			)
				.find('input[name="search-criteria"]:checked')
				.val()}`
		);

		$(this.element).find(selectors.standings).html(data);

		this.setMatchlinks();
		$(window).trigger('flexgrid');
	}

	setMatchlinks() {
		$(this.element)
			.find('a.c-competition-poule-match-row__data--link')
			.each(function (i, el) {
				el.href = `${el.href}${window.location.search}`;
			});
	}

	setHistory(state) {
		history.replaceState(
			'search',
			document.title,
			`${window.location.href.split('?')[0]}?${state}`
		);
	}

	getHistory(field) {
		if (window.location.search.length === 0) {
			return '';
		}

		if (field === null || typeof field === 'undefined') {
			if (
				this.getHistory('s') !== 0 &&
				this.getHistory('l') !== 0 &&
				this.getHistory('c') !== 0 &&
				this.getHistory('g') !== 0 &&
				this.getHistory('cl') !== 0 &&
				this.getHistory('t') !== 0
			) {
				return `seasonid=${this.getHistory('s')}&leagueid=${this.getHistory(
					'l'
				)}&classid=${this.getHistory('c')}&groupid=${this.getHistory(
					'g'
				)}&clubid=${this.getHistory('cl')}&teamid${this.getHistory('t')}`;
			} else {
				return '';
			}
		}

		let fields = window.location.search.substring(1).split('&');
		for (let i = 0; i < fields.length; i++) {
			if (fields[i].split('=').length === 2 && fields[i].split('=')[0] === field)
				return fields[i].split('=')[1];
		}

		return 0;
	}
}

/*
 * Create a new instance for each carousel on current page
 */
$(selectors.competition).each(function () {
	new Competition(this);
});
